// @ts-strict-ignore
import {Component, OnInit} from "@angular/core";
import {Translations} from "@translations";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {Scope, SimRole, TileData, WebClientType} from "@models";
import {
	ClientApplicationTile,
	IPermissionOverrule,
	SimConfigurationService,
	SimDashboardTileService,
	SimMaterialDialogService,
	SimMenuApptileService,
	NotificationService,
	SimSystemService,
	SimUserExtendedService,
	SimUtilityService,
} from "@services";
import {moveItemInArray} from "@angular/cdk/drag-drop";
import {zoomInOnEnterAnimation, zoomOutOnLeaveAnimation} from "angular-animations";

@Component({
	selector: "sim-settings-page-dashboard-configuration",
	templateUrl: "./settings-page-dashboard-configuration.component.html",
	styleUrls: ["./settings-page-dashboard-configuration.component.scss"],
	animations: [zoomInOnEnterAnimation({duration: 175}), zoomOutOnLeaveAnimation({duration: 175})],
	standalone: false,
})
export class SettingsPageDashboardConfigurationComponent implements OnInit {
	T = Translations;
	WebClientType = WebClientType;
	Scope = Scope;

	public dashboardSelectionFormGroup = new FormGroup({
		role: new FormControl<string>("Admin", Validators.required),
		clientType: new FormControl<WebClientType>(WebClientType.Recorder, Validators.required),
		scope: new FormControl<Scope>(SimConfigurationService.settings.license.scope, Validators.required),
	});
	public loadingDashboardTiles: boolean = true;
	public currentApplicationTiles: ClientApplicationTile[] = [];
	private lastLoadedDashboardTiles: ClientApplicationTile[] = [];
	public saveSpecifigDashboardTilesPromise: Promise<void>;
	public savingDashboard: boolean = false;
	public currentTileInEditMode: number;

	configurableRoles: SimRole[] = [];
	configurableDevices: WebClientType[] = [
		WebClientType.Recorder,
		WebClientType.Tablet,
		WebClientType.ViewingStation,
		WebClientType.External,
	];

	public permissionOverrule: IPermissionOverrule = {
		permissions: null,
		webClientTypes: null,
	};

	constructor(
		private _dashboardTileService: SimDashboardTileService,
		private _simNotificationService: NotificationService,
		private _simMaterialDialogService: SimMaterialDialogService,
		public _simUserServer: SimUserExtendedService,
		private _simMenuApptileService: SimMenuApptileService,
		private _simSystemService: SimSystemService,
	) {
		this.dashboardSelectionFormGroup.valueChanges.subscribe(async (data) => {
			this.permissionOverrule.webClientTypes = [data.clientType];
			this.permissionOverrule.permissions = await this._simSystemService.getRolePermissions(data.role);
			if (data.clientType == WebClientType.External) {
				this.permissionOverrule.isExternal = true;
			}

			this.getSpecifigDashboardTiles();
		});
	}

	async ngOnInit() {
		const hostRole = "Host";
		let user = this._simUserServer.user;
		let primaryRole = user.isHost ? hostRole : user.roleIds?.[0];
		this.dashboardSelectionFormGroup.controls.role.setValue(primaryRole, {
			emitEvent: true,
		});
		this.configurableRoles = await this._simSystemService.getSimRolesForUpsertUser();
		if (user.isHost) {
			this.configurableRoles.unshift(<any>(<Partial<SimRole>>{id: hostRole, name: hostRole}));
		}
	}

	private getSpecifigDashboardTiles() {
		this.loadingDashboardTiles = true;

		// setTimeout(() => {
		// 	this.dashboardSelectionFormGroup.controls.role.disable();
		// 	//this.dashboardSelectionFormGroup.controls.role.enable();
		//
		// }, 1000);
		// setTimeout(() => {
		// 	//this.dashboardSelectionFormGroup.controls.role.disable();
		// 	this.dashboardSelectionFormGroup.controls.role.enable();
		//
		// }, 3000);

		this.dashboardSelectionFormGroup.disable({emitEvent: false});
		//
		// debugger;

		let dashboardTilePromise = this._dashboardTileService
			.getSpecificDashboardTiles(
				this.dashboardSelectionFormGroup.controls.clientType.value,
				this.dashboardSelectionFormGroup.controls.role.value,
			)
			.then((data) => {
				if (data) {
					this.currentApplicationTiles = [];
					for (const application of data?.applications) {
						let appTile = this._simMenuApptileService.ApplicationTilesMap.get(application);
						this.currentApplicationTiles.push(appTile);
					}
					this.lastLoadedDashboardTiles = Object.assign([], this.currentApplicationTiles);
				} else {
					this.currentApplicationTiles = [];
					this.lastLoadedDashboardTiles = [];
				}
			});

		SimUtilityService.promiseTakeAtLeast(1000, dashboardTilePromise).then(() => {
			this.loadingDashboardTiles = false;
			this.dashboardSelectionFormGroup.enable({emitEvent: false});
		});
	}

	moveDashboardItemDown(index: number) {
		moveItemInArray(this.currentApplicationTiles, index, index + 1);
	}

	moveDashboardItemUp(index: number) {
		moveItemInArray(this.currentApplicationTiles, index, index - 1);
	}

	noChanges(): boolean {
		return SimUtilityService.arrayEquals(
			this.currentApplicationTiles.map(x=>x?.id),
			this.lastLoadedDashboardTiles.map(x=>x?.id)
		);
	}

	public saveDashboardTiles() {
		this.savingDashboard = true;
		this.saveSpecifigDashboardTilesPromise = SimUtilityService.promiseTakeAtLeast(
			1000,
			this._dashboardTileService
				.saveDashboardTiles({
					clientType: this.dashboardSelectionFormGroup.controls.clientType.value,
					roleId: this.dashboardSelectionFormGroup.controls.role.value,
					applications: this.currentApplicationTiles.map((clientApplicationTile) => clientApplicationTile?.id),
				})
				.then((res) => {
					if (res.success) {
						this._simNotificationService.notifySuccess();
						this.getSpecifigDashboardTiles();
					}
				}),
		).then(() => {
			this.savingDashboard = false;
		});
	}

	moveDashboardItem(index: number) {
		this.currentTileInEditMode = index;
		this._simMaterialDialogService
			.openConfigureAppTileDialog({
				currentlyUsedApplications: this.currentApplicationTiles.map((clientApplicationTile) => clientApplicationTile?.id),
				permissionOverrule: this.permissionOverrule,
			})
			.then((dialogRes) => {
				this.currentTileInEditMode = -1;

				if (dialogRes.action === "ok") {
					//If -42 is returned then the tile should be removed
					if (dialogRes.newClientApplication === -42) {
						this.removeDashboardTile(index);
					} else {
						this.currentApplicationTiles[index] = this._simMenuApptileService.ApplicationTilesMap.get(
							dialogRes.newClientApplication,
						);
					}
				}
			});
	}

	discardCurrentChanges() {
		this.currentApplicationTiles = Object.assign([], this.lastLoadedDashboardTiles);
	}

	resetToDefault() {
		SimUtilityService.promiseTakeAtLeast(
			500,
			this._dashboardTileService
				.resetDashboardTilesToDefault({
					roleId: this.dashboardSelectionFormGroup.controls.role.value,
					clientType: this.dashboardSelectionFormGroup.controls.clientType.value,
				})
				.then((res) => {
					if (res.success) {
						this.getSpecifigDashboardTiles();
						this._simNotificationService.notifySuccess();
					}
				}),
		).then();
	}

	removeDashboardTile(index: number) {
		this.currentApplicationTiles.splice(index, 1);
		//keep the array length static
		this.currentApplicationTiles.length = 13;
	}

	public readonly TileData: TileData;
}
